export default __webpack_public_path__ + "static/media/formaldehyde.f671a96b.svg";